import qrcode from "qrcode-generator";

const QUIET_ZONE = 4;
const BRAND_COLOR = "#457be7";
const MODULE_COLOR = "#111827";
/** Доля полотна под плашку с логотипом. Уровень коррекции H переживает такую перекрышку. */
const LOGO_RATIO = 0.22;

export interface QrOptions {
  /** Логотип в центре и фирменные угловые метки. Содержимое ссылки не меняется. */
  branded: boolean;
  logo?: HTMLImageElement | null;
}

/** Угловые поисковые метки — их и красим в фирменный цвет. */
function isFinderModule(row: number, col: number, count: number): boolean {
  return (
    (row < 7 && col < 7) ||
    (row < 7 && col >= count - 7) ||
    (row >= count - 7 && col < 7)
  );
}

export function drawQr(
  canvas: HTMLCanvasElement,
  url: string,
  size: number,
  { branded, logo }: QrOptions,
): HTMLCanvasElement {
  const qr = qrcode(0, "H");
  qr.addData(url);
  qr.make();

  const count = qr.getModuleCount();
  const scale = Math.max(1, Math.floor(size / (count + QUIET_ZONE * 2)));
  const side = (count + QUIET_ZONE * 2) * scale;

  canvas.width = side;
  canvas.height = side;

  const ctx = canvas.getContext("2d");
  if (!ctx) return canvas;

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, side, side);

  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (!qr.isDark(row, col)) continue;
      ctx.fillStyle =
        branded && isFinderModule(row, col, count) ? BRAND_COLOR : MODULE_COLOR;
      ctx.fillRect((QUIET_ZONE + col) * scale, (QUIET_ZONE + row) * scale, scale, scale);
    }
  }

  if (branded && logo?.complete && logo.naturalWidth > 0) {
    const box = Math.round(side * LOGO_RATIO);
    const pad = Math.round(box * 0.1);
    const offset = Math.round((side - box) / 2);

    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    if (typeof ctx.roundRect === "function") {
      ctx.roundRect(offset, offset, box, box, Math.round(box * 0.18));
      ctx.fill();
    } else {
      ctx.fillRect(offset, offset, box, box);
    }
    ctx.drawImage(logo, offset + pad, offset + pad, box - pad * 2, box - pad * 2);
  }

  return canvas;
}

export function qrDataUrl(
  url: string,
  size: number,
  options: QrOptions,
): string {
  return drawQr(document.createElement("canvas"), url, size, options).toDataURL("image/png");
}
